export const contentConstants = {
  SEARCH_SUBMIT_START: "SEARCH_SUBMIT_START",
  SEARCH_SUBMIT_SUCCESS: "SEARCH_SUBMIT_SUCCESS",
  SEARCH_SUBMIT_FAILURE: "SEARCH_SUBMIT_FAILURE",

  FAQS_SUBMIT_START: "FAQS_SUBMIT_START",
  FAQS_SUBMIT_SUCCESS: "FAQS_SUBMIT_SUCCESS",
  FAQS_SUBMIT_FAILURE: "FAQS_SUBMIT_FAILURE",

  LINKS_SUBMIT_START: "LINKS_SUBMIT_START",
  LINKS_SUBMIT_SUCCESS: "LINKS_SUBMIT_SUCCESS",
  LINKS_SUBMIT_FAILURE: "LINKS_SUBMIT_FAILURE",
};
